const statusList = {
  ALL: false,
  PENDING: false,
  CANCEL: false,
  DONE: false,
};

export default statusList;
